module.exports = __webpack_public_path__ + "a9be46b948c7b038ae75ffd0eb7d7b8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/workout-blue.png
// module id = 1888
// module chunks = 1